import * as React from "react"
import type { SVGProps } from "react"
const SvgReplyAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m4.83 11.71 3.9 3.9q.3.3.28.7a1 1 0 0 1-.31.7q-.3.28-.7.3a1 1 0 0 1-.7-.3l-4.6-4.6a1 1 0 0 1-.21-.32 1 1 0 0 1-.07-.38q0-.2.07-.37A1 1 0 0 1 2.7 11l4.6-4.6a1 1 0 0 1 .69-.27q.4 0 .71.27.3.3.3.72 0 .4-.3.7zm6 1 2.9 2.9q.3.3.28.7a1 1 0 0 1-.31.7q-.3.28-.7.3a1 1 0 0 1-.7-.3l-4.6-4.6a1 1 0 0 1-.21-.32 1 1 0 0 1-.06-.38q0-.2.06-.37A1 1 0 0 1 7.7 11l4.6-4.6a1 1 0 0 1 .69-.27q.4 0 .71.27.3.3.3.72 0 .4-.3.7l-2.87 2.88H17q2.07 0 3.54 1.47A4.8 4.8 0 0 1 22 15.7v3q0 .44-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72v-3q0-1.25-.87-2.12A3 3 0 0 0 17 12.7z" />
  </svg>
)
export default SvgReplyAll
